module.exports = __webpack_public_path__ + "static/img/left.56f44a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left.png
// module id = 87
// module chunks = 1